export enum PartRelationshipType {
	Standard = 0,
	MasterAssembly = 10,
	ChildPart = 20,
}